export const navigate = (href) => {
    const anchorLink = document.createElement("a");
    anchorLink.href = href;
    anchorLink.rel = "noreferrer noopener";

    anchorLink.click();
    anchorLink.remove();
};
